import { PolicyCheck } from '@/features/auth/authorization';

export const SettingsPolicies: Record<string, PolicyCheck> = {
  'settings.view': ({ acl, user, meta }) => {
    return acl.settings.view;
  },
  'settings.edit': ({ acl, user, meta }) => {
    return acl.settings.edit;
  },
  'settings.powerups.view': ({ acl, user, meta }) => {
    return acl.settings.powerups.view;
  },
  'settings.powerups.edit': ({ acl, user, meta }) => {
    return acl.settings.powerups.edit;
  },
};
